import { useStoreState } from "app/store";
import { isServer } from "common/helpers/envChecker";

export function useRequestId() {
  const requestId = useStoreState(state => state.app.requestId);
  return isServer() ? requestId : "";
}
